module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/reg-login-505180b8ade6f59f2831c1582de22199.svg";